import { HeroSection } from '@/components/sections/HeroSection';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { SectorsSection } from '@/components/sections/SectorsSection';
import { FeaturedProductsSection } from '@/components/sections/FeaturedProductsSection';
import { CTASection } from '@/components/sections/CTASection';
import { Footer } from '@/components/layouts/Footer';
import { TracingBeam } from '@/components/ui/tracing-beam';
import { useSanityContext } from '@/sanity/SanityDataProvider';

/**
 * R2 - INBOCA Homepage assembling all sections
 * R4 - Fetches Sanity data via context, passes to sections with fallback
 * 
 * TracingBeam runs along the left side, connecting all sections visually
 */
export function HomePage() {
  const { data } = useSanityContext();

  return (
    <TracingBeam>
      <HeroSection data={data?.hero} contactInfo={data?.contactInfo} />
      <ServicesSection data={data?.services} />
      <SectorsSection data={data?.sectors} />
      <FeaturedProductsSection data={data?.products} />
      <CTASection data={data?.cta} contactInfo={data?.contactInfo} />
      <Footer data={data?.footer} contactInfo={data?.contactInfo} />
    </TracingBeam>
  );
}
